export default function capitalize(str, oneChar) {
    return str.charAt(0).toUpperCase() + (oneChar ? '' : str.slice(1));
}
//# sourceMappingURL=stringUtils.js.map